import { SearchActions } from "~/types/actions.enum";
import { NormalizedCategory, NormalizedTopic, SEARCH_TABS } from "~/types/search.types";

// ✅ Initial states
export const initialState: TCacheState = {
    graphicsCategories: [],
    graphicsTopics: [],
    reportsCategories: [],
    reportsTopics: []
};

// ✅ Types

// Action type defn
export type TCacheAction =
    | { type: SearchActions.SET_CACHE_CATEGORIES; payload: ISetCacheListParams }
    | { type: SearchActions.SET_CACHE_TOPICS; payload: ISetCacheListParams };

// State type defns
export type TCacheState = {
    /** Normalized Topics `NormalizedTopic[]` cache of graphics type */
    graphicsTopics: NormalizedTopic[];
    /** Normalized Topics `NormalizedTopic[]` cache of reports type */
    reportsTopics: NormalizedTopic[];
    /** Normalized Categories `NormalizedCategory[]` cache of graphics type */
    graphicsCategories: NormalizedCategory[];
    /** Normalized Categories `NormalizedCategory[]` cache of reports type */
    reportsCategories: NormalizedCategory[];
};

export interface ISetCacheListParams {
    data: NormalizedCategory[] & NormalizedTopic[];
    // domain: SEARCH_ITEMS,
    type: SEARCH_TABS;
}

// Store type
export type TCacheMethods = "dispatch" | "reset";

export type TCacheStore = TCacheState & {
    /**
     * Sets the Cache state using a reducer pattern.
     * @param {TCacheAction} action - `TCacheAction` action to apply.
     * @example
     * ```
     * const dispatch = useCacheStore((state) => state.dispatch)
     * dispatch({ type: SearchActions.SET_CACHE_TOPICS, payload: disclosuresList })
     * ```
     */
    dispatch: (action: TCacheAction) => void;
    /**
     * Resets the store to its initial state
     */
    reset: () => void;
};
